/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useEffect, useRef, useState } from "react";
import dots from "../assets/images/greay_drag.svg";
import dragWhite from "../assets/images/drag_white.svg";
import angleDown from "../assets/images/angle_up_down.svg";
import imagedrage from "../assets/images/model/image-icon.svg";
import video from "../assets/images/model/video_icon.svg";
import audioIcon from "../assets/images/model/audio-icon.svg";
import plusCricle from "../assets/images/model/plus-addmedia.svg";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";
import "react-h5-audio-player/lib/styles.css";
import "./questionstypes.css";
import ImageUploadQ from "../Pages/Book/questionTypeMedia/ImageUploadQ";
import AudioUploadQ from "../Pages/Book/questionTypeMedia/AudioUploadQ";
import VideoUploadQ from "../Pages/Book/questionTypeMedia/VideoUploadQ";

const OrderListQuestions = ({ questionss, setQuestionss, isEditing }) => {
  const isS3Url = (url) => {
    return url.includes("s3.amazonaws.com");
  };

  const isYouTubeUrl = (url) => {
    return url.includes("youtube.com") || url.includes("youtu.be");
  };
  const audioRef = useRef();
  const [textareaHeights, setTextareaHeights] = useState(
    questionss.map((question) => question.options.map(() => 40))
  );
  const [showImageUploadModal, setShowImageUploadModal] = useState(false);
  const [showAudioUploadModal, setShowAudioUploadModal] = useState(false);
  const [showVideoUploadModal, setShowVideoUploadModal] = useState(false);

  const [selectedOptionIndex, setSelectedOptionIndex] = useState(null);
  const [selectedQuestionIndex, setSelectedQuestionIndex] = useState(null);
  const handleInputChange = (e, questionIndex, optionIndex) => {
    const { value } = e.target;

    // Update textarea height if necessary
    const textarea = e.target;
    textarea.style.height = "auto";
    const newHeight = textarea.scrollHeight;
    textarea.style.height = `${newHeight}px`;

    setTextareaHeights((prevHeights) => {
      const newHeights = [...prevHeights];
      newHeights[questionIndex][optionIndex] = newHeight;
      return newHeights;
    });

    // Update text value in questionss
    setQuestionss((oldQuestions) =>
      oldQuestions.map((question, index) =>
        index === questionIndex
          ? {
              ...question,
              options: question.options.map((option, oi) =>
                oi === optionIndex ? { ...option, text: value } : option
              ),
            }
          : question
      )
    );
  };

  const getDragHandleHeight = (optionType, currentHeight) => {
    const defaultHeights = {
      text: 40,
      image: 148,
      video: 148,
      audio: 115,
    };
    const defaultHeight = defaultHeights[optionType] || 148;

    return defaultHeight + Math.max(currentHeight - 40, 0);
  };

  const onDragEnd = (result) => {
    if (!result.destination) {
      return;
    }

    const { source, destination } = result;

    setQuestionss((oldQuestions) => {
      const copiedQuestions = [...oldQuestions];
      const sourceQuestion = copiedQuestions[source.droppableId];

      if (source.droppableId === destination.droppableId) {
        const reorderedOptions = Array.from(sourceQuestion.options);
        const [removed] = reorderedOptions.splice(source.index, 1);
        reorderedOptions.splice(destination.index, 0, removed);
        sourceQuestion.options = reorderedOptions;
      } else {
        return oldQuestions;
      }

      return copiedQuestions;
    });
  };

  /* Upload Media to Options */
  const handleImageOptionClick = (questionIndex, optionIndex) => {
    setSelectedQuestionIndex(questionIndex);
    setSelectedOptionIndex(optionIndex);
    setShowImageUploadModal(true);
  };
  const handleAudioOptionClick = (questionIndex, optionIndex) => {
    setSelectedQuestionIndex(questionIndex);
    setSelectedOptionIndex(optionIndex);
    setShowAudioUploadModal(true);
  };
  const handleVideoOptionClick = (questionIndex, optionIndex) => {
    setSelectedQuestionIndex(questionIndex);
    setSelectedOptionIndex(optionIndex);
    setShowVideoUploadModal(true); // Show video modal
  };
  const handleImageUploaded = (imageFile) => {
    const updatedQuestions = questionss.map((question, qIndex) => {
      if (qIndex === selectedQuestionIndex) {
        return {
          ...question,
          options: question.options.map((option, oIndex) =>
            oIndex === selectedOptionIndex ? { ...option, imageFile } : option
          ),
        };
      }
      return question;
    });

    setQuestionss(updatedQuestions);
    setShowImageUploadModal(false);
    setSelectedQuestionIndex(null);
    setSelectedOptionIndex(null);
  };

  const handleAudioUploaded = (audioFile) => {
    const updatedQuestions = questionss.map((question, qIndex) => {
      if (qIndex === selectedQuestionIndex) {
        return {
          ...question,
          options: question.options.map((option, oIndex) =>
            oIndex === selectedOptionIndex ? { ...option, audioFile } : option
          ),
        };
      }

      return question;
    });

    setQuestionss(updatedQuestions);
    setShowAudioUploadModal(false);
    setSelectedQuestionIndex(null);
    setSelectedOptionIndex(null);
  };

  const handleVideoUploaded = (videoUrl) => {
    const updatedQuestions = questionss.map((question, qIndex) => {
      if (qIndex === selectedQuestionIndex) {
        return {
          ...question,
          options: question.options.map((option, oIndex) =>
            oIndex === selectedOptionIndex
              ? { ...option, videoFile: videoUrl }
              : option
          ),
        };
      }
      return question;
    });

    setQuestionss(updatedQuestions);
    setShowVideoUploadModal(false);
    setSelectedQuestionIndex(null);
    setSelectedOptionIndex(null);
  };

  /* ......................... */

  /* For Audio Source */
  const formatTime = (time) => {
    if (!time) return "0:00";
    const minutes = Math.floor(time / 60);
    const seconds = Math.floor(time % 60);
    return `${minutes}:${seconds < 10 ? "0" : ""}${seconds}`;
  };

  return (
    <DragDropContext onDragEnd={onDragEnd}>
      {questionss.map((question, questionIndex) => (
        <div key={questionIndex}>
          {question.type === "orderlist" && (
            <Droppable droppableId={questionIndex.toString()} type="OPTIONS">
              {(provided) => (
                <div ref={provided.innerRef} {...provided.droppableProps}>
                  {question.options.map((option, optionIndex) => (
                    <Draggable
                      key={option.order}
                      draggableId={`${questionIndex}-${option.order}`}
                      index={optionIndex}
                      isDragDisabled={!isEditing}
                    >
                      {(provided, snapshot) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          className={`orderlist-item ${
                            snapshot.isDragging ? "dragging" : ""
                          } ${!isEditing ? "save_state_border" : ""}`}
                        >
                          {isEditing ? (
                            <RenderEditOption
                              snapshot={snapshot}
                              provided={provided}
                              option={option}
                              questionIndex={questionIndex}
                              optionIndex={optionIndex}
                              textareaHeights={textareaHeights}
                              handleInputChange={handleInputChange}
                              handleImageOptionClick={handleImageOptionClick}
                              handleAudioOptionClick={handleAudioOptionClick}
                              handleVideoOptionClick={handleVideoOptionClick}
                              getDragHandleHeight={getDragHandleHeight}
                              isS3Url={isS3Url}
                              isYouTubeUrl={isYouTubeUrl}
                              formatTime={formatTime}
                              audioRef={audioRef}
                            />
                          ) : (
                            <RenderSavedOption
                              isEditing={isEditing}
                              provided={provided}
                              option={option}
                              questionIndex={questionIndex}
                              optionIndex={optionIndex}
                              textareaHeights={textareaHeights}
                              handleImageOptionClick={handleImageOptionClick}
                              handleAudioOptionClick={handleAudioOptionClick}
                              handleVideoOptionClick={handleVideoOptionClick}
                              getDragHandleHeight={getDragHandleHeight}
                              isS3Url={isS3Url}
                              isYouTubeUrl={isYouTubeUrl}
                              formatTime={formatTime}
                              audioRef={audioRef}
                            />
                          )}
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          )}
        </div>
      ))}
      {showImageUploadModal && (
        <ImageUploadQ
          onImageUploadedQ={handleImageUploaded}
          setUploadImageShow={setShowImageUploadModal}
        />
      )}
      {showAudioUploadModal && (
        <AudioUploadQ
          onAudioUploadedQ={handleAudioUploaded}
          setShowAudioUploadModal={setShowAudioUploadModal}
        />
      )}
      {showVideoUploadModal && (
        <VideoUploadQ
          onAudioUploadedQ={handleVideoUploaded}
          setShowVideoUploadModal={setShowVideoUploadModal}
        />
      )}
    </DragDropContext>
  );
};
const RenderEditOption = ({
  provided,
  option,
  questionIndex,
  optionIndex,
  textareaHeights,
  handleInputChange,
  handleImageOptionClick,
  handleAudioOptionClick,
  handleVideoOptionClick,
  getDragHandleHeight,
  isS3Url,
  isYouTubeUrl,
  formatTime,
  audioRef,
  snapshot,
}) => {
  return (
    <>
      <div
        {...provided.dragHandleProps}
        className={`drag-handle_order ${
          snapshot.isDragging ? "border_right" : ""
        }`}
        style={{
          height: `${getDragHandleHeight(
            option.type,
            textareaHeights[questionIndex][optionIndex]
          )}px`,
          minHeight: `${
            option.type === "image" || option.type === "video"
              ? "148px"
              : option.type === "audio"
              ? "115px"
              : "40px"
          }`,
        }}
      >
        <img
          src={snapshot.isDragging ? dragWhite : dots}
          className="image_drag"
          alt="dots"
        />
      </div>
      <div className="parent_input_with_image">
        <div className={`parent_input `}>
          <div className={`order-number `}>
            <span
              className={`order-number-box ${
                snapshot.isDragging ? "order_font_color" : ""
              }`}
            >
              {option.order}
            </span>
          </div>
          <textarea
            id={`textarea-${questionIndex}-${optionIndex}`}
            className={`orderlist-input `}
            placeholder={
              option.type === "text" ? `Add text` : `Add text (optional)`
            }
            rows={1}
            value={option.text}
            onChange={(e) => handleInputChange(e, questionIndex, optionIndex)}
            style={{
              height: `${textareaHeights[questionIndex][optionIndex]}px`,
              color: snapshot.isDragging ? "#6700b2" : "",
            }}
          />

          <div className="dropdown-arrow">
            <img src={angleDown} alt="down arrow" />
          </div>
        </div>

        {(option.type === "image" || option.type === "video") && (
          <div>
            <div className="image_parent" style={{ paddingTop: "0px" }}>
              <div className="order-number"></div>
              {option.imageFile ? (
                <div className="input_image">
                  <img
                    className="upload_image_order"
                    src={option.imageFile}
                    alt=""
                  />
                </div>
              ) : option.videoFile ? (
                <div className="input_image video_order_list">
                  {isS3Url(option.videoFile) ? (
                    <video controls className="video_order_list">
                      <source src={option.videoFile} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : isYouTubeUrl(option.videoFile) ? (
                    <iframe
                      className="video_order_list"
                      style={{ borderRadius: "4px" }}
                      src={option.videoFile}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  ) : (
                    <div
                      className="input_image"
                      onClick={() =>
                        handleVideoOptionClick(questionIndex, optionIndex)
                      }
                    >
                      <img
                        src={video}
                        alt="video"
                        style={{ display: "block" }}
                      />
                      <img src={plusCricle} className="plus_icon" alt="plus" />
                    </div>
                  )}
                </div>
              ) : (
                <div
                  className="input_image"
                  onClick={() => {
                    if (option.type === "image") {
                      handleImageOptionClick(questionIndex, optionIndex);
                    } else if (option.type === "video") {
                      handleVideoOptionClick(questionIndex, optionIndex);
                    }
                  }}
                >
                  <img
                    src={option.type === "image" ? imagedrage : video}
                    alt="image"
                    style={{ display: "block" }}
                  />
                  <img src={plusCricle} className="plus_icon" alt="plus" />
                </div>
              )}
              <div className="dropdown-arrow"></div>
            </div>
          </div>
        )}

        {option.type === "audio" && (
          <div className="image_parent" style={{ paddingTop: "0px" }}>
            <div className="order-number"></div>
            {option.audioFile ? (
              <div className="audio_boarder_order">
                <div className="deflat_content audio_file_parent">
                  <span className="audio_file">{option.audioFile.name}</span>
                  <span className="audio_size">
                    {formatTime(option.audioDuration)} (
                    {Math.round(option.audioFile.size / (1024 * 1024))} MB)
                  </span>
                </div>

                <AudioPlayer
                  ref={audioRef}
                  style={{ width: "100%" }}
                  src={URL.createObjectURL(option.audioFile)}
                  customAdditionalControls={[]}
                  customVolumeControls={[]}
                  showJumpControls={false}
                  customProgressBarSection={[
                    RHAP_UI.CURRENT_TIME,
                    <div className="slash_time" key="slash">
                      /
                    </div>,
                    RHAP_UI.DURATION,
                    RHAP_UI.PROGRESS_BAR,
                  ]}
                />
              </div>
            ) : (
              <div
                className="input_image input_audio"
                onClick={() =>
                  handleAudioOptionClick(questionIndex, optionIndex)
                }
              >
                <img src={audioIcon} alt="audio" style={{ display: "block" }} />
                <img src={plusCricle} className="plus_icon" alt="plus" />
              </div>
            )}
            <div className="dropdown-arrow"></div>
          </div>
        )}
      </div>
    </>
  );
};

const RenderSavedOption = ({
  option,
  questionIndex,
  optionIndex,
  textareaHeights,
  getDragHandleHeight,
  isS3Url,
  isYouTubeUrl,
  formatTime,
  audioRef,
  isEditing,
}) => {
  const [textHeight, setTextHeight] = useState(32); // Initial height, adjust as needed

  useEffect(() => {
    // Function to calculate text height
    const calculateTextHeight = (text) => {
      const font = "12px Inter"; // Adjust to match your CSS properties
      const lineHeight = 1.35; // 135% line-height
      const maxWidth = 400; // Adjust as needed

      const div = document.createElement("div");
      div.style.position = "absolute";
      div.style.visibility = "hidden";
      div.style.width = `${maxWidth}px`;
      div.style.font = font;
      div.style.lineHeight = lineHeight;
      div.innerText = text;
      document.body.appendChild(div);
      const height = div.offsetHeight;
      document.body.removeChild(div);
      return height;
    };

    // Initial calculation on mount or update
    if (option.text) {
      const height = calculateTextHeight(option.text);
      setTextHeight(height);
    }

    // Event listener for window resize
    const handleResize = () => {
      if (option.text) {
        const height = calculateTextHeight(option.text);
        setTextHeight(height);
      }
    };

    window.addEventListener("resize", handleResize);

    // Cleanup on unmount
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, [option.text]); // Update when option.text changes

  return (
    <>
      <div
        className="drag-handle_order opacity_3 drag-handle_save"
        style={{
          minHeight:
            option.type === "image" || option.type === "video"
              ? "142px"
              : option.type === "audio"
              ? "67px"
              : "32px", // Minimum height
          height: `${textHeight}px`, // Set the calculated height dynamically
        }}
      >
        <img src={dots} className="image_drag drag_opacity" alt="dots" />
      </div>
      <div className="parent_input_with_image">
        <div className="parent_input">
          <div className="order-number order-number_save">
            <span className="order-number-box order-number-box_save checkbox_border_color">
              {option.order}
            </span>
          </div>
          <div>
            {option.text && (
              <div
                className="orderlist-input option_save_state"
                style={{
                  minHeigh: "32px",
                  height: "auto",
                  paddingRight: !isEditing ? "20px" : "",
                }}
              >
                {option.text}
              </div>
            )}
            {option.audioFile && (
              <div
                style={{ paddingTop: "8px" }}
                className={`deflat_content audio_file_parent_order  order_audio_pad ${
                  option.text ? "padding_none " : ""
                }`}
              >
                <span className="audio_file">Audio file</span>
                <span className="view_transcript">View transcript</span>
              </div>
            )}
          </div>
        </div>

        {(option.type === "image" || option.type === "video") && (
          <div>
            <div className="image_parent" style={{ paddingTop: "2px" }}>
              <div className="order-number"></div>
              {option.imageFile ? (
                <div className="input_image">
                  <img
                    className="upload_image_order"
                    src={option.imageFile}
                    alt=""
                  />
                </div>
              ) : option.videoFile ? (
                <div className="input_image video_order_list">
                  {isS3Url(option.videoFile) ? (
                    <video controls className="video_order_list">
                      <source src={option.videoFile} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  ) : isYouTubeUrl(option.videoFile) ? (
                    <iframe
                      className="video_order_list"
                      style={{ borderRadius: "4px" }}
                      src={option.videoFile}
                      title="YouTube video player"
                      frameBorder="0"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      referrerPolicy="strict-origin-when-cross-origin"
                      allowFullScreen
                    ></iframe>
                  ) : (
                    <div className="input_image">
                      <img
                        src={video}
                        alt="video"
                        style={{ display: "block" }}
                      />
                      <img src={plusCricle} className="plus_icon" alt="plus" />
                    </div>
                  )}
                </div>
              ) : (
                <div className="input_image">
                  <img
                    src={option.type === "image" ? imagedrage : video}
                    alt="image"
                    style={{ display: "block" }}
                  />
                  <img src={plusCricle} className="plus_icon" alt="plus" />
                </div>
              )}
              <div className="dropdown-arrow"></div>
            </div>
          </div>
        )}

        {option.type === "audio" && (
          <div className="image_parent" style={{ padding: "2px" }}>
            {option.audioFile ? (
              <div className="audio-save_state">
                <AudioPlayer
                  ref={audioRef}
                  style={{ width: "100%" }}
                  src={URL.createObjectURL(option.audioFile)}
                  customAdditionalControls={[]}
                  customVolumeControls={[]}
                  showJumpControls={false}
                  customProgressBarSection={[
                    RHAP_UI.CURRENT_TIME,
                    <div className="slash_time" key="slash">
                      /
                    </div>,
                    RHAP_UI.DURATION,
                    RHAP_UI.PROGRESS_BAR,
                  ]}
                />
              </div>
            ) : (
              <>
                <div className="dropdown-arrow"></div>
                <div
                  className="input_image input_audio"
                  style={{ padding: "10px" }}
                >
                  <img
                    src={audioIcon}
                    alt="audio"
                    style={{ display: "block" }}
                  />
                  <img src={plusCricle} className="plus_icon" alt="plus" />
                </div>
                <div className="dropdown-arrow"></div>
              </>
            )}
          </div>
        )}
      </div>
    </>
  );
};

export default OrderListQuestions;
